import { Grid } from '@material-ui/core';
import { MerchantContract } from '@nemuru-eng/js-api-client';

import { CompanyManagerDetails } from './CompanyManagerDetails';
import { MerchantDetails } from './MerchantDetails';

interface DetailsProps {
  merchantContract: MerchantContract;
}

export const Details = ({ merchantContract }: DetailsProps) => {
  return (
    <>
      <Grid spacing={4} container>
        <Grid item xs={12} lg={6}>
          <MerchantDetails merchantContract={merchantContract} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <CompanyManagerDetails merchantContract={merchantContract} />
        </Grid>
      </Grid>
    </>
  );
};
